import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { PlatformLocation } from '@angular/common';
import Swal from 'sweetalert2'
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FeitoConferidoService {

  feitoConferidoGet$ = new BehaviorSubject(null);
  feitoConferidoPost$ = new BehaviorSubject(null);
  feitoConferidoPut$ = new BehaviorSubject(null);
  feitoConferidoDelete$ = new BehaviorSubject(null);

  constructor(private http: HttpClient, private platformLocation: PlatformLocation) { }

  get() {
    try {
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/FeitoConferido/dashboard_de_feitoconferido/" + environment.empresa + "/" + environment.cd_usuario;

      this.http.get(url).subscribe({
        next: (data) => this.feitoConferidoGet$.next(data),
        error: (error: HttpErrorResponse) => {
          this.feitoConferidoGet$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.feitoConferidoGet$.unsubscribe(),
          this.feitoConferidoGet$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
      throw e;
    }
  }

  post(evento: any) {
    try {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');

      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/FeitoConferido/Acao"
      evento.empresa = environment.empresa;
      evento.cd_usuario_aprova = environment.cd_usuario;

      this.http.post(url, evento, { headers: headers })
        .subscribe({
          next: (res: any) => this.feitoConferidoPost$.next(res),
          error: (error: HttpErrorResponse) => {
            if (error.status === 500) {
              Swal.fire({
                'width': 500,
                'title': 'Oops...',
                'text': error.error.detail,
                'icon': 'error'
              });
            } else {
              Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
            }
          }
        }).add(() => {
          this.feitoConferidoPost$.unsubscribe(),
            this.feitoConferidoPost$ = new BehaviorSubject(null);
        });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
      throw e;
    }
  }
}
